import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeThirdpartyDiscntThirdparty from './ChangeThirdpartyDiscntThirdparty';
import ChangeThirdpartyDiscntDriver from './ChangeThirdpartyDiscntDriver';
import ChangeThirdpartyDamageFinancial from './ChangeThirdpartyDamageFinancial';
import ChangeThirdpartyDamageHuman from './ChangeThirdpartyDamageHuman';
import ChangeThirdpartyDamageDriver from './ChangeThirdpartyDamageDriver';
import ChangeThirdpartyCoverage from './ChangeThirdpartyCoverage';
import ChangeThirdpartyUsefore from './ChangeThirdpartyUsefore';
import ChangeThirdpartyTime from './ChangeThirdpartyTime';
import ChangePriceThirdParty from './ChangePriceThirdParty';
import ChangeThirdpartyMode from './ChangeThirdpartyMode';



const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeThirdparty extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:9,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
            <div style={{dir:'ltr',direction: 'ltr'}}>
                 <AppBar style={{dir:'ltr'}} position="sticky"color="primary" >

                   <Tabs
                    style={{height:'60px',textAlign:'center',dir:'ltr'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="on"
                               aria-label="scrollable force tabs example"
                   >
                     <Tab label=" تخفیف ثالث"  />
                     <Tab label="تخفیف راننده"  />
                     <Tab label="خسارت مالی"  />
                     <Tab label="خسارت جانی"  />
                     <Tab label="خسارت راننده"  />
                     <Tab label="پوشش بیمه"  />
                     <Tab label="مورد استفاده"  />
                     <Tab label="مدت زمان بیمه"  />
                     <Tab label="نوع طرح"  />
                     <Tab label="قیمت بیمه"  />
                     </Tabs>


                 </AppBar>
                 {(value===0)?<ChangeThirdpartyDiscntThirdparty  props={this.props}/>:null}
                 {(value===1)?<ChangeThirdpartyDiscntDriver  props={this.props}/>:null}
                 {(value===2)?<ChangeThirdpartyDamageFinancial  props={this.props}/>:null}
                 {(value===3)?<ChangeThirdpartyDamageHuman  props={this.props}/>:null}
                 {(value===4)?<ChangeThirdpartyDamageDriver  props={this.props}/>:null}
                 {(value===5)?<ChangeThirdpartyCoverage  props={this.props}/>:null}
                 {(value===6)?<ChangeThirdpartyUsefore  props={this.props}/>:null}
                 {(value===7)?<ChangeThirdpartyTime  props={this.props}/>:null}
                 {(value===8)?<ChangeThirdpartyMode  props={this.props}/>:null}
                 {(value===9)?<ChangePriceThirdParty  props={this.props}/>:null}
               </div>
        );
    }
}


export default  withStyles(styles)(ChangeThirdparty);
